import axios from "axios";


export function getReferralsList(params) {
  return axios.get(
    `${process.env.REACT_APP_API_URL_V1}/referrals/search_list.json`,
    { params: params }
  );
}

export function getReferralsMeta() {
  return axios.get(
    `${process.env.REACT_APP_API_URL_V1}/referrals/meta.json`,
    { params: {} }
  );
}

export function saveReferral(patientId, data) {
  return axios.post(
    `${process.env.REACT_APP_API_URL_V1}/referrals/save.json`,
    data,
    { params: { pid: patientId } }
  );
}
export function getReferalNumber() {
  return axios.get(
    `${process.env.REACT_APP_API_URL_V1}/Utilities/referral_random_num.json`,
    { params:{prefix:'REF'}}
  );
}
export function getReferralPrintId(params){
  return axios.get(
  `${process.env.REACT_APP_API_URL_V1}/referrals/print_pdf.json`,
  { params: {id:params.id,
    current_loc: "patient/referrals/referrals",width: 600} });
}